const HeroSection = () => {
  return (
    <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#007bbb] via-[#0099dd] to-[#00aaee]"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        <div className="inline-block border-2 border-white bg-transparent px-6 py-2 rounded-full mb-6">
          <span className="text-white text-xs font-medium tracking-widest uppercase">NEWS</span>
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white">
          お知らせ
        </h1>
      </div>
    </section>
  );
};

export default HeroSection;
